<template>
    <PatientFiles />
</template>
  
<script>
import PatientFiles from '@/views/components/patients/PatientFiles.vue';

export default {
  components: {
    PatientFiles,
  },
};
</script>